import React from "react";
import Styles from "./DateSection.module.css";
import { IBillingCycleData } from "../../hooks/patients/useFetchBillingCyclePdf";

interface ScoreSectionProps {
  billingCycleData?: IBillingCycleData | null;
  consentDate?: string;
}

const DateSection: React.FC<ScoreSectionProps> = ({
  billingCycleData,
  consentDate,
}) => {
  return (
    <div className={Styles.dateSection}>
      <div className={Styles.dateCard}>
        <div className={Styles.dateCardTitle}>RTM CYCLE (START DATE)</div>
        <div className={Styles.dateCardDate}>
          {billingCycleData?.billingCycleStartDate || "N/A"}
        </div>
      </div>
      <div className={Styles.dateCard}>
        <div className={Styles.dateCardTitle}>CONSENT DATE</div>

        <div className={Styles.dateCardDate}> {consentDate || "N/A"}</div>
      </div>
    </div>
  );
};

export default DateSection;
